let gCtx = null;
let gCanvas = null;
const c = 0;
let stype = 0;
let gUM = false;
let webkit = false;
const moz = false;
let v = null;

const imghtml = "<div id=\"qrfile\"><canvas id=\"out-canvas\" width=\"320\" height=\"240\"></canvas>" +
    "<div id=\"imghelp\">drag and drop a QRCode here" +
    "<br>or select a file" +
    "<input type=\"file\" onchange=\"handleFiles(this.files)\"/>" +
    "</div>" +
    "</div>";

const vidhtml = "<video id=\"v\" autoplay playsinline muted></video>";

function dragenter(e){
    e.stopPropagation();
    e.preventDefault();
}

function dragover(e){
    e.stopPropagation();
    e.preventDefault();
}
function drop(e){
    e.stopPropagation();
    e.preventDefault();

    const dt = e.dataTransfer;
    const files = dt.files;
    if(files.length > 0){
        handleFiles(files);
    }
    else
        if(dt.getData("URL")){
            qrcode.decode(dt.getData("URL"));
        }
}

function handleFiles(f){
    const o = [];

    for(let i = 0; i < f.length; i++){
        const reader = new FileReader();
        reader.onload = (function (theFile){
            return function (e){
                gCtx.clearRect(0, 0, gCanvas.width, gCanvas.height);

                qrcode.decode(e.target.result);
            };
        })(f[i]);
        reader.readAsDataURL(f[i]);
    }
}

function initCanvas(){
    gCanvas = document.getElementById("qr-canvas");
    gCanvas.style.width = 100 + "%";
    gCanvas.style.height = 100 + "%";

    const w = gCanvas.getBoundingClientRect().width;
    const h = gCanvas.getBoundingClientRect().height;

    gCanvas.width = w;
    gCanvas.height = h;

    gCtx = gCanvas.getContext("2d");
    gCtx.clearRect(0, 0, w, h);
}


function captureToCanvas(){
    if(stype != 1)
        return;
    if(gUM){
        try{
            gCanvas.width = v.videoWidth;
            gCanvas.height = v.videoHeight;

            gCtx.drawImage(v, 0, 0, v.videoWidth, v.videoHeight);
            try{
                qrcode.decode();
            }catch(e){
                console.log(e);
                setTimeout(captureToCanvas, 50);
            }
        }catch(e){
            console.log(e);
            setTimeout(captureToCanvas, 50);
        }
    }
}

function htmlEntities(str){
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

function read(a){
    document.querySelector(".ref-number").value = a;
    document.querySelector(".seek-btn.button").click();
}

function isCanvasSupported(){
    const elem = document.createElement("canvas");
    return!!(elem.getContext && elem.getContext("2d"));
}
function success(stream){

    v.srcObject = stream;
    v.play();

    gUM = true;
    setTimeout(captureToCanvas, 50);
}

function error(error){
    gUM = false;
    return;
}

export default function load(){
    if(!document.getElementById("qr-canvas"))return;

    if(isCanvasSupported() && window.File && window.FileReader){
        initCanvas();
        qrcode.callback = read;
        document.getElementById("mainbody").style.display = "inline";
        setwebcam();
    }
    else{
        document.getElementById("mainbody").style.display = "inline";
        document.getElementById("mainbody").innerHTML = "<p id=\"mp1\">QR code scanner for HTML5 capable browsers</p><br>" +
            "<br><p id=\"mp2\">sorry your browser is not supported</p><br><br>" +
            "<p id=\"mp1\">try <a href=\"http://www.mozilla.com/firefox\"><img src=\"firefox.png\"/></a> or <a href=\"http://chrome.google.com\"><img src=\"chrome_logo.gif\"/></a> or <a href=\"http://www.opera.com\"><img src=\"Opera-logo.png\"/></a></p>";
    }
}

function setwebcam(){
    let options = { facingMode: { exact: "environment" } };
    if(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices){
        navigator.mediaDevices.enumerateDevices()
            .then(function (devices){
                let foundBackCamera = false;
                devices.forEach(function (device){
                    if(device.kind === "videoinput"){
                        if(device.label.toLowerCase().includes("back")){
                            options = { facingMode: { exact: "environment" } };
                            foundBackCamera = true;
                        }
                    }
                });
                if(!foundBackCamera){
                    console.log("No back camera explicitly found. Defaulting to environment facingMode.");
                }
                setwebcam2(options);
            }).catch(function (e){
                console.log(e);
                setwebcam2(options);
            });
    }else{
        console.log("MediaDevices interface not available. Using default options.");
        setwebcam2(options);
    }
}


function setwebcam2(options){
    if(stype == 1){
        setTimeout(captureToCanvas, 50);
        return;
    }
    const n = navigator;
    document.getElementById("outdiv").innerHTML = vidhtml;
    v = document.getElementById("v");


    if(n.mediaDevices && n.mediaDevices.getUserMedia){
        n.mediaDevices.getUserMedia({ video: options, audio: false }).
            then(function (stream){
                success(stream);
            }).catch(function (error){
                error(error);
            });
    }
    else
        if(n.getUserMedia){
            webkit = true;
            n.getUserMedia({ video: options, audio: false }, success, error);
        }
        else
            if(n.webkitGetUserMedia){
                webkit = true;
                n.webkitGetUserMedia({ video: options, audio: false }, success, error);
            }

    document.getElementById("qrimg").style.opacity = 0.2;
    document.getElementById("webcamimg").style.opacity = 1.0;

    document.getElementById("qrimg")?.addEventListener("click", setimg);
    document.getElementById("webcamimg")?.addEventListener("click", setwebcam);

    stype = 1;
    setTimeout(captureToCanvas, 50);
}

function setimg(){
    if(stype == 2)
        return;
    document.getElementById("outdiv").innerHTML = imghtml;
    //document.getElementById("qrimg").src="qrimg.png";
    //document.getElementById("webcamimg").src="webcam2.png";
    document.getElementById("qrimg").style.opacity = 1.0;
    document.getElementById("webcamimg").style.opacity = 0.2;
    const qrfile = document.getElementById("qrfile");
    qrfile.addEventListener("dragenter", dragenter, false);
    qrfile.addEventListener("dragover", dragover, false);
    qrfile.addEventListener("drop", drop, false);
    stype = 2;
}